import React from 'react';

import { FormControl, Box, FormHelperText, TextField } from '@mui/material';
import type { TextFieldPropsWithEdit } from '@/types';

interface ChartNameFieldProps extends TextFieldPropsWithEdit {
  label?: string;
}

export default function ChartNameField({
  value,
  error,
  setValue,
  setError,
  setChanged,
  edit,
  label,
}: ChartNameFieldProps): React.JSX.Element {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const { value: newValue } = event.target;
    setChanged();
    setValue(newValue);
    if (/[#^$<>+%!`&*'"|{}?/\\:=@]/.test(newValue)) {
      setError('Chart name cannot contain #^$<>+%!`&*\'"|{}?/\\:=@');
    } else if (newValue === '') {
      setError('Chart name cannot be blank');
    } else {
      setError(false);
    }
  };

  return (
    <Box>
      <FormControl fullWidth required>
        <TextField
          label={label ? label : 'Chart Name'}
          id='name'
          aria-describedby='name-helper-text'
          variant='outlined'
          onChange={handleChange}
          error={Boolean(error)}
          value={value}
          disabled={edit}
          slotProps={{ inputLabel: { shrink: value?.length > 0 } }}
        />
        {error ? (
          <FormHelperText id='name-helper-text'>{error}</FormHelperText>
        ) : (
          <FormHelperText id='name-helper-text'>
            Enter a name for the chart
          </FormHelperText>
        )}
      </FormControl>
    </Box>
  );
}

